
import { mapState, mapActions } from 'vuex'
import ThemePaging from '~/components/Theme/ThemePaging'
import SearchInputField from '~/components/Common/UI/Search/SearchInputField'

export default {
    name: 'ThemeStockSearch',
    components:{
        SearchInputField,
        ThemePaging,
    },
    data() {
        return {
            curPage: 1,
            countByPage: 30,
            params: null,
            stock: {},                // 종목코드,종목명 저장변수 
            isThemeStockSearch: true, // 하위컴포넌트에 테마DB구분값 전달 
        }
    },
    computed: {
        ...mapState('theme', ['themeList']),
        setTotalCount() {
            let count = 0
            if (this.themeList) {
                count = this.themeList.totalCount
            }
            console.log('count', count)
            return count
        },
    },
    created() {
        this.params = { pageNo: this.curPage, countByPage: this.countByPage }
        this.GET_THEMELIST(this.params)
    },
    methods: {
        ...mapActions('modal', ['SHOW_ALERT']),
        ...mapActions('theme', ['GET_THEMELIST', 'GET_STOCKTHEMESEARCH']),
        onClickPage(page) {
            this.curPage = page
            this.params.pageNo = page
            this.GET_THEMELIST(this.params)
            // this.GET_STOCKTHEMESEARCH(this.stock.stockCode)
        },
        // 테마 디테일 이동
        onClickDetail(code) {
            if (code > 0) {
                this.$router.push(`/Theme/ThemeDB/${code}`)
            } else {
                this.SHOW_ALERT({ content: '해당 테마를 찾지 못했습니다.' })
            }
        },
        searchStockTheme(stock){ 
            this.stock = {stockCode: stock.stockCode, stockName: stock.stockName}
            if (stock.stockCode != null){
                this.GET_STOCKTHEMESEARCH(this.stock.stockCode)
                // console.log('GET_STOCKTHEMESEARCH', this.themeList)
            } else {
                this.SHOW_ALERT({ content: '종목이 선택되지 않았습니다.' })
            }
        },
    },
}
